import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-banner',
  templateUrl: './banner.component.html',
  styleUrls: ['./banner.component.scss']
})
export class BannerComponent {
  @Input() visible = false;
  @Input() message = '';
  @Input() type = 'info';
  @Input() linkText = '';
  @Output() linkClick = new EventEmitter<void>();
}



// WEBPACK FOOTER //
// ./src/app/shared/banner.component.ts